<template>
  <div class="is-inline-flex is-relative">
    <Popover
      v-if="popoverPosition"
      ref="popover"
      class="is-inline-flex"
      :position="popoverPosition"
      :use-fixed-positions="true"
    >
      <template #trigger>
        <div class="has-text-primary has-text-weight-semibold">
          {{ document.title }}
        </div>
      </template>
      <template #content>
        <div class="legal-reasoning p-3">
          <div class="is-flex is-align-items-center is-full-width is-justify-content-space-between">
            <div class="is-flex is-align-items-center">
              <img
                v-if="document.sourceEnum?.icon"
                :src="document.sourceEnum.icon"
                class="source-icon"
              />
              <span
                v-if="document.sourceEnum?.value"
                class="m-l-5 has-text-weight-semibold is-size-5"
              >
                {{ document.sourceEnum.value }}
              </span>
            </div>
            <IconView
              pack="cls"
              size="is-small"
              custom-class="cls-remove"
              class="is-clickable is-pulled-right is-relative xy-b-10 has-text-primary is-size-6"
              @click="onClickClose"
              :data-e2e="AICypressAttribute.buttons.CLARA_LEGAL_REASONING_CLOSE_ICON"
            />
          </div>
          <div
            class="mt-2 m-b-1 has-text-secondary-grey is-uppercase has-text-weight-semibold is-size-6"
          >
            {{ document.title }}
          </div>
          <ClaraLegalReasoningSourceContent
            :content="source.content"
            class="source-content is-overflow-y-auto pb-1 p-r-10"
          />
        </div>
      </template>
    </Popover>
  </div>
</template>

<script>
import ClaraLegalReasoningSourceContent from '@/modules/ai/components/presentational/ClaraLegalReasoningSourceContent.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';
import { EstateRagDocumentObject } from '@/modules/ai/models/EstateRagDocumentObject';
import { EstateRagSimilarityDataObject } from '@/modules/ai/models/EstateRagSimilarityDataObject';
import Popover from '@/modules/core/ui/components/Popover.vue';
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraLegalReasoningSourceTitle',
  components: {
    Popover,
    ClaraLegalReasoningSourceContent,
    IconView
  },
  props: {
    document: {
      EstateRagDocumentObject,
      required: true
    },
    source: {
      type: EstateRagSimilarityDataObject,
      required: true
    }
  },
  static: {
    AICypressAttribute
  },
  data() {
    return {
      popoverPosition: null
    };
  },
  methods: {
    setPosition() {
      if (!this.$el) {
        return;
      }

      this.popoverPosition =
        this.$el.getBoundingClientRect().left > window.innerWidth / 2
          ? 'is-top-left'
          : 'is-top-right';
    },
    onClickClose() {
      this.$refs.popover.toggle();
    }
  },
  mounted() {
    this.setPosition();
  }
};
</script>

<style scoped>
.legal-reasoning {
  line-height: 1.2;
  width: var(--ce-400px);
  cursor: auto;

  .source-icon {
    height: var(--ce-20px);
  }

  .source-content {
    max-height: var(--ce-300px);
  }
}
</style>
